// extracted by mini-css-extract-plugin
export default {"external":"a3h2V","label":"b3h2V"};